// extracted by mini-css-extract-plugin
export var disabled = "_q-6";
export var hierarchyLinkGray = "_q-a";
export var hierarchyLinkUnderline = "_q-9";
export var hierarchyPrimary = "_q-0";
export var hierarchySecondary = "_q-7";
export var hierarchyTertiary = "_q-8";
export var pressed = "_q-2";
export var themeAction = "_q-1";
export var themeDestructive = "_q-4";
export var themeNormal = "_q-3";
export var themeSuccess = "_q-5";